<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ year }} Financials</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" v-b-modal.financial-modal v-if="canAddEdit">New</base-button>
          <base-button size="sm" type="neutral" v-b-toggle.filters>
            <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
              <span class="btn-inner--text">Filters</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <observed-upgrade-overlay :title="year + ' Financials'" :upgradeImg="'overlays/expenses.png'" :placeholderImg="'placeholders/expenses.png'" v-if="!subscribed"></observed-upgrade-overlay>
      <b-row v-else>
        <b-col>
          <div v-if="expenses">
            <expenses-table
              :title="'Financials'"
              :data="expenses"
              :categories="categories"
              :primarySources="primarySources"
              :tableColumns="columns"
              :isBusy="isBusy"
              :userRoute="userRoute"
              :canAddEdit="canAddEdit"
              @getExpenses="getExpenses"
              @updateYear="updateYear"
              @updateFinancial="updateFinancial"
              @exportFinancials="exportFinancials"
            ></expenses-table>
          </div>
          <loading-panel v-else class="mt-4"></loading-panel>
        </b-col>
      </b-row>
      <financial-modal @getExpenses="getExpenses" :userRoute="userRoute" :financial="financial"></financial-modal>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LoadingPanel from '@/components/LoadingPanel';
import {Select, Option} from 'element-ui'
import ExpensesTable from '@/views/Components/Tables/ExpensesTable';
import columns from './columns';
import expensesMixin from '@/mixins/expenses-mixin';
import sourcesMixin from '@/mixins/sources-mixin';
import ObservedUpgradeOverlay from '@/views/Components/Overlays/ObservedUpgradeOverlay';
import FinancialModal from '@/views/Components/Modals/FinancialModal';

export default {
  mixins: [expensesMixin, sourcesMixin],
  components: {
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    ExpensesTable,
    ObservedUpgradeOverlay,
    FinancialModal
  },
  data() {
    return {
      validated: false,
      expenses: null, 
      columns: columns,
      year: new Date().getFullYear(),
      categories: [],
      isBusy: true,
      financial: null
    };
  },
  computed: {
    ...mapGetters({
      subBasic: 'observed/subBasic',
      subStandard: 'observed/subStandard',
      subPremium: 'observed/subPremium'
    }),
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    subscribed() {
      return this.subBasic + this.subStandard || this.subPremium;
    },
    canAddEdit() {
      const observed = this.$store.getters['observed/observed'];
      const userRoles = this.$store.getters['roles/roles'];
      return (observed.roles.includes('owner') || observed.roles.includes('agent')) && (userRoles.includes('owner') || userRoles.includes('editor'));
    }
  },
  methods: {
    updateYear(year) {
      this.year = year;
    },
    updateFinancial(financial) {
      this.financial = financial;
      this.$bvModal.show('financial-modal');
    }
  },
  created() {
    this.getExpenses();
    this.getMreaSelect();
  },
  mounted() {
    document.title = "Observatory Financials | ClarityNOW";
  },
  watch: {
    year(to, from) {
      this.getExpenses();
    }
  }
}
</script>